export const APP_ROUTE = {
	placeAd: {
		base: 'placead',
		success: 'placead/success',
	},
	auth: {
		login: 'login',
	},
};
